export function getSubStepDrivenKey(
  isAddSpacesStep: boolean,
  isSpaceDetailsStep: boolean,
  addSpacesLevelUniqueId: string | undefined,
  spaceDetailsCategory: string | undefined,
  spaceDetailsLevelUniqueId: string | undefined
): string | undefined {
  if (isAddSpacesStep && addSpacesLevelUniqueId) {
    return `add_spaces:${addSpacesLevelUniqueId}`;
  }
  if (isSpaceDetailsStep && spaceDetailsCategory && spaceDetailsLevelUniqueId) {
    return `space_details:${spaceDetailsCategory}:${spaceDetailsLevelUniqueId}`;
  }
  return undefined;
}
